// extracted by mini-css-extract-plugin
export var banner = "_2q-0";
export var icon = "_2q-1";
export var message = "_2q-2";